import React, { useState } from 'react';
import { Tabs, Radio } from 'antd';

const { TabPane } = Tabs;

export default function ShopMenu(props){
    const {selectedItem, setSelecetdItem} = props

    return (
    <div className="menutabs">
          <Tabs activeKey={selectedItem} onTabClick={(e)=>{setSelecetdItem(e)}}type="card" size="large" >
      <TabPane tab="Lahvové pivo" key="beerItems">
      </TabPane>
      <TabPane tab="Dárkové předměty" key="giftItems">
      </TabPane>
      {/* <TabPane tab="Sklo a další" key="glassItems">
      </TabPane> */}
    </Tabs>

    </div>
      );
}


